// Angular Imports
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
// Shared Imports
import { LowerCaseNumberPipe } from '@shared/pipes'

@Component({
	selector: 'app-pill',
	standalone: true,
	imports: [LowerCaseNumberPipe],
	templateUrl: './pill.component.html',
	styleUrls: ['./pill.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PillComponent {
	@Input({ required: true }) value = ''
	@Input() isFull = false
}
